import React from 'react'
import DetailIcon from '@/common/detail-icon';
import './index.less';

export default function Header(props: {
  i18n: DetailTypes.I18n
}) {
  const { i18n } = props;
  return (
    <div className='quick-header-layout'>
      <div className='quick-header'>
        <h3>{i18n['pc_quick_view_pop']}</h3>
        <div className='header-icon' onClick={() => {
          window.parent.postMessage({
            from: 'quickView',
            event: 'close',
            action: 'close'
          }, '*');
        }}>
          <DetailIcon symbol='icon-close-fill' className={'detail-symbol'} />
        </div>
      </div>
    </div>
  )
}
